import React, {useState, useEffect, useContext} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import { fetchPaymentSessionStatus } from '../../http/userAPI';
import {Context} from "../../index";
import {PAY_ROUTE, USER_DASHBOARD_ROUTE} from "../../utils/consts";
import {Button, Card, CardBody, Col, Row, Table, ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import UserPaySubscriptionFull from "./UserPaySubscriptionFull"; // Используем API-запрос

const Return = () => {
    const [status, setStatus] = useState(null);
    const [customerEmail, setCustomerEmail] = useState('');


    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get('session_id');

        if (sessionId) {
            fetchPaymentSessionStatus(sessionId)
                .then((data) => {
                    if (data) {
                        setStatus(data.status);
                        setCustomerEmail(data.customer_email);
                    }
                })
                .catch((error) => console.error('Status Payment Error:', error));
        }
    }, []);

    const { user } = useContext(Context);
    const navigate = useNavigate();
    const [selectedPrice, setSelectedPrice] = useState(null); // ✅ Храним выбранный тариф
    const [billingCycle, setBillingCycle] = useState("monthly"); // ✅ "monthly" или "yearly"
    // Список тарифов с их ценами
    const plans = [
        {
            name: "FREE",
            monthlyPriceId: "",
            yearlyPriceId: "",
            Book_Limit: "Only One",
            Assign_Limit: "Two at the time",
            Track_Review: "Full Access",
            Library: "Limit Access",
            Photo_Review: "Limit Access",
            Search_Buy: "No Access",
            Library_Filter: "Limit Access",
            Support: "Limit Access",
            Trust_Score: "Lower Points",
            monthlyPrice: "$0.00 Mo",
            yearlyPrice: "$0.00 Yr",
            logo: "./logo/virtalibry_dark_free_no_bg.png"
        },
        {
            name: "ESSENTIAL",
            monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_ESSENTIAL_MONTHLY,
            yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_ESSENTIAL_EARLY,
            Book_Limit: "Only One",
            Assign_Limit: "Two at the time",
            Track_Review: "Full Access",
            Library: "Limit Access",
            Photo_Review: "Limit Access",
            Search_Buy: "No Access",
            Library_Filter: "Limit Access",
            Support: "Limit Access",
            Trust_Score: "Lower Points",
            monthlyPrice: "$9.99 Mo",
            yearlyPrice: "$99.99 Yr",
            logo: "./logo/virtalibry_dark_es_no_bg.png"
        },
        {
            name: "PREMIUM",
            monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_MONTHLY,
            yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_EARLY,
            Book_Limit: "Only One",
            Assign_Limit: "Two at the time",
            Track_Review: "Full Access",
            Library: "Limit Access",
            Photo_Review: "Limit Access",
            Search_Buy: "No Access",
            Library_Filter: "Limit Access",
            Support: "Limit Access",
            Trust_Score: "Lower Points",
            monthlyPrice: "$19.99 Mo",
            yearlyPrice: "$199.99 Yr",
            logo: "./logo/virtalibry_dark_pr_no_bg.png"
        },
        {
            name: "MAXIMUM",
            monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_MAXIMUM_MONTHLY,
            yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_MAXIMUM_EARLY,
            Book_Limit: "Only One",
            Assign_Limit: "Two at the time",
            Track_Review: "Full Access",
            Library: "Limit Access",
            Photo_Review: "Limit Access",
            Search_Buy: "No Access",
            Library_Filter: "Limit Access",
            Support: "Limit Access",
            Trust_Score: "Lower Points",
            monthlyPrice: "$29.99 Mo",
            yearlyPrice: "$299.99 Yr",
            logo: "./logo/virtalibry_dark_max_no_bg.png"
        }
    ];

    if (status === 'open') {
        return navigate(PAY_ROUTE);// Если статус платежа "open", перенаправляем на страницу оплаты
    }

    if (status === 'complete') {

        return (
            <Row>
                {selectedPrice ? ('') : (
                    <>
                        {/* ✅ Переключатель Месяц/Год */}
                        <Col md={12} className="text-center mb-4">
                           <h3>Congratulations, Payment Successful!</h3>
                            <Button
                                variant="success"
                                className="mt-3 mb-3"
                                   onClick={() =>
                                  navigate(USER_DASHBOARD_ROUTE)
                                }
                            >
                               <strong>Go to Customer Dashboard</strong>
                            </Button>
                            <Card
                                className="shadow-lg p-0"
                                style={{
                                    borderRadius: "6px", // ✅ Скругленные углы
                                    width: "40vw", // ✅ 40% ширины экрана
                                    maxWidth: "600px", // ✅ Ограничение максимальной ширины
                                    padding: "20px", // ✅ Внутренний отступ для лучшего вида
                                    margin: "0 auto", // ✅ Центрируем карточку
                                }}
                            >
                                <CardBody>
                                    <h6 className="text-muted">
                                        You can always manage your subscription independently through the user portal in your dashboard.
                                        You can switch to any other plan with an automatic recalculation of the remaining days.
                                        Canceling your subscription is also possible at any time at your discretion.
                                    </h6>
                                </CardBody>
                            </Card>

                        </Col>
                    </>
                )}
                <Col mb={2}>

                </Col>

                <Col mb={2}>

                </Col>
            </Row>
        );
    }

    return <div>Loading...</div>;
};

export default Return;
